module.exports = __webpack_public_path__ + "static/media/Moonchild.b4865c68.jpg";